import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/homeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/about.vue')
  },
  {
    path: '/table',
    name: 'Table',
    component: () => import(/* webpackChunkName: "start" */ '../views/start.vue')
  }
  ,
  {
    path: '/hospitals',
    name: 'Hospitals',
    component: () => import(/* webpackChunkName: "start" */ '../views/homeView.vue')
  },
  {
    path: '/projects',
    name: 'Projects',
    component: () => import(/* webpackChunkName: "start" */ '../views/projectsView.vue')
  },
  {
    path: '/devices',
    name: 'Devices',
    component: () => import(/* webpackChunkName: "start" */ '../views/devicesView.vue')
  },
  {
    path: '/assets',
    name: 'Assets',
    component: () => import(/* webpackChunkName: "start" */ '../views/assetsView.vue')
  },
  {
    path: '/tests',
    name: 'Tests',
    component: () => import(/* webpackChunkName: "start" */ '../views/testsView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
